<template>
  <div class="auth-wrapper auth-v2">
    <div class="auth-inner">
      <v-avatar
        size="30px"
        color="#f4f5fa"
        class="brand-logo d-flex align-center me-3"
      >
        <v-img
          :src="appLogo"
          alt="logo"
          contain
          eager
        />
      </v-avatar>

      <v-row class="auth-row ma-0">
        <v-col
          lg="8"
          class="d-none d-lg-block position-relative overflow-hidden pa-0"
        >
          <div class="auth-illustrator-wrapper">
            <!-- triangle bg -->
            <!-- <img
              height="362"
              class="auth-mask-bg"
              :src="require(`@/assets/images/misc/mask-v2-${$vuetify.theme.dark ? 'dark' : 'light'}.png`)"
            /> -->

            <!-- tree -->
            <!-- <v-img
              height="226"
              width="300"
              class="auth-tree"
              src="@/assets/images/misc/tree.png"
            ></v-img> -->

            <!-- 3d character -->
            <div class="d-flex align-center h-full pa-16 pe-0">
              <v-img
                contain
                max-width="100%"
                height="510"
                class="auth-3d-group"
                :src="require(`@/assets/images/logos/TECH_Horizontal_${$vuetify.theme.dark ? 'White' : 'Color'}.png`)"
              />
            </div>
          </div>
        </v-col>

        <v-col
          lg="4"
          class="d-flex align-center auth-bg pt-16"
        >
          <v-row>
            <v-col
              sm="8"
              md="6"
              lg="12"
              cols="12"
              class="mx-auto"
            >
              <v-card flat>
                <v-card-text>
                  <p class="text-2xl font-weight-semibold text--primary mb-2">
                    Atualizar senha 🔒
                  </p>
                  <p class="mb-2">
                    Sua nova senha deve ser diferente da senha anterior
                  </p>
                  <p>
                    <i>
                      Copiar e colar código enviado por e-mail. Verifique também lixo eletrônico e SPAM.
                    </i>
                  </p>
                </v-card-text>

                <v-card-text>
                  <v-form
                    ref="formRef"
                    @submit.prevent="handleSubmitBtnClick"
                  >
                    <v-text-field
                      v-model="request.tokenConfirmacao"
                      class="mb-3"
                      dense
                      outlined
                      label="Token de confirmação"
                      autocomplete="one-time-code"
                      hide-details="auto"
                      validate-on-blur
                      :rules="[validators.required]"
                    />

                    <v-text-field
                      v-model="request.novaSenha"
                      class="mb-3"
                      dense
                      outlined
                      label="Nova senha"
                      placeholder="············"
                      hide-details="auto"
                      :type="isPasswordVisible ? 'text' : 'password'"
                      :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline "
                      :rules="[validators.passwordValidator, validators.required]"
                      @click:append="isPasswordVisible = !isPasswordVisible"
                    />

                    <v-text-field
                      v-model="request.confirmarSenha"
                      class="mb-3"
                      dense
                      outlined
                      label="Confirmar senha"
                      placeholder="············"
                      hide-details="auto"
                      :type="isConfirmPasswordVisible ? 'text' : 'password'"
                      :append-icon="isConfirmPasswordVisible ? icons.mdiEyeOffOutline:icons.mdiEyeOutline"
                      :rules="[validators.required, validators.passwordValidator, validators.confirmedValidator(request.novaSenha, request.confirmarSenha)]"
                      @click:append="isConfirmPasswordVisible = !isConfirmPasswordVisible"
                    />

                    <v-btn
                      class="mt-4"
                      block
                      type="submit"
                      color="primary"
                    >
                      <v-progress-circular
                        v-if="loading"
                        indeterminate
                        color="secundary"
                      />

                      <span v-else>Atualizar senha</span>
                    </v-btn>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<style lang="scss">
@import '@core/preset/preset/pages/auth.scss';
</style>

<script>
import Vue from 'vue'
import { ref } from '@vue/composition-api'
import { mdiChevronLeft, mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import { alphaValidator, confirmedValidator, emailValidator, passwordValidator, required } from '@core/utils/validation'
import themeConfig from '@themeConfig'
import router from '@/router'
import AuthService from '@/services/modules/AuthService'
import useForm from '@/composables/useForm'

export default {
  setup() {
    const { formRef, loading, FORM_ERROR, validateForm } = useForm()

    const isPasswordVisible = ref(false)
    const isConfirmPasswordVisible = ref(false)

    const request = ref({
      email: router.currentRoute.query.email || '',
      tokenConfirmacao: '',
      novaSenha: '',

    })

    function goToAuthLogin() {
      router.push({ name: 'auth-login' })
    }

    async function handleSubmitBtnClick() {
      if (loading.value) return

      if (!validateForm()) {
        Vue.$toast.warning(FORM_ERROR)
        return
      }

      try {
        loading.value = true

        await AuthService.resetarSenha(this.request)

        goToAuthLogin()
      } finally {
        loading.value = false
      }
    }

    return {
      formRef,
      loading,

      isPasswordVisible,
      isConfirmPasswordVisible,

      request,

      handleSubmitBtnClick,

      appLogo: themeConfig.app.logo,

      icons: {
        mdiChevronLeft,
        mdiEyeOutline,
        mdiEyeOffOutline,
      },

      validators: {
        confirmedValidator,
        required,
        emailValidator,
        passwordValidator,
        alphaValidator,
      },
    }
  },
}
</script>
